import { Message } from '@bedrock/components';
import { ProText } from '@bedrock/eed-react';
import { Copy } from '@bedrock/icons-react';
import { EllipsisTooltip } from '@mpc/components';
import copy from 'copy-to-clipboard';
import React from 'react';
import { FC } from 'react';

export const ProTextWithCopy: FC<any> = (props) => {
  const render = (value: any) => {
    if (!value) {
      return '-';
    }
    return (
      <div className="flex items-center">
        <EllipsisTooltip text={value} />
        <Copy
          className="ml-[4px]"
          style={{ color: '#68768F' }}
          onClick={() => {
            copy(value);
            Message.success({ content: '复制成功' });
          }}
        />
      </div>
    );
  };
  return <ProText {...props} fieldProps={{}} render={render} />;
};
